import _toConsumableArray from "/codebuild/output/src145264479/src/LandingPage/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useQueue, randomId } from '@mantine/hooks';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
function useNotificationsState(_ref) {
  var limit = _ref.limit;
  var _useQueue = useQueue({
      initialValues: [],
      limit: limit
    }),
    state = _useQueue.state,
    queue = _useQueue.queue,
    update = _useQueue.update,
    cleanQueue = _useQueue.cleanQueue;
  var showNotification = function showNotification(notification) {
    var id = notification.id || randomId();
    update(function (notifications) {
      if (notification.id && notifications.some(function (n) {
        return n.id === notification.id;
      })) {
        return notifications;
      }
      return [].concat(_toConsumableArray(notifications), [__spreadProps(__spreadValues({}, notification), {
        id: id
      })]);
    });
    return id;
  };
  var updateNotification = function updateNotification(notification) {
    return update(function (notifications) {
      var index = notifications.findIndex(function (n) {
        return n.id === notification.id;
      });
      if (index === -1) {
        return notifications;
      }
      var newNotifications = _toConsumableArray(notifications);
      newNotifications[index] = notification;
      return newNotifications;
    });
  };
  var hideNotification = function hideNotification(id) {
    return update(function (notifications) {
      return notifications.filter(function (notification) {
        if (notification.id === id) {
          typeof notification.onClose === "function" && notification.onClose(notification);
          return false;
        }
        return true;
      });
    });
  };
  var clean = function clean() {
    return update(function () {
      return [];
    });
  };
  return {
    notifications: state,
    queue: queue,
    showNotification: showNotification,
    updateNotification: updateNotification,
    hideNotification: hideNotification,
    cleanQueue: cleanQueue,
    clean: clean
  };
}
export default useNotificationsState;